<template>
    <div name="description-of-soldoc2" class="description-of-soldoc2">
        <div class="description-of-soldoc2-inner">
            <div class="box-contents">
                <div>
                    <span>바로솔닥</span>
                    <strong>무리한 가격 경쟁 없이도<br>우리 병원 찾는 환자가 늘어요</strong>
                    <p>가격 경쟁을 지양하고 단골 병원 재진을 유도하여<br>기존 환자 유실 없이 더 많은 신환을 유치할 수 있어요.</p>
                </div>
                <div>
                    <span>바로솔닥</span>
                    <strong>야간, 공휴일 비대면진료로<br>더 많은 환자와 더 자주 만나요</strong>
                    <p>야간과 공휴일에는 모든 환자를 간편하게<br>비대면진료로 만날 수 있어요.</p>
                </div>
                <div>
                    <span>바로돌봄</span>
                    <strong>하루 딱 30분, 돌봄센터 어르신과<br>정기적으로 비대면진료 보세요</strong>
                    <p>솔닥파트너스를 통해 제휴 돌봄센터의 거동이 불편한 어르신들께<br>효율적인 비대면진료를 제공할 수 있어요.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "description-of-soldoc2",
    data: function() {
        return {};
    },
    computed: {},
    mounted: function() {
        $(window).scroll(function() {
            var height = $(document).scrollTop();
            var innerTop = $(".description-of-soldoc2-inner").offset().top;
            var aniItem = $(".description-of-soldoc2-inner .box-contents");

            if (height <= 0) {
                $(aniItem).removeClass('item-show').addClass('item-hide');
            } else if (height > innerTop - 500 && height < innerTop + 1300) {
                $(aniItem).removeClass('item-hide').addClass('item-show');
            } else if (height > innerTop + 1300) {
                $(aniItem).removeClass('item-show').addClass('item-hide');
            }
        });
    },
};
</script>

<style scoped>
.description-of-soldoc2 {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 1215px;
    background: #FFF;
    overflow: hidden;
}
.description-of-soldoc2 .description-of-soldoc2-inner {    
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1240px;
    padding: 129px 20px 106px;
}
.description-of-soldoc2 .description-of-soldoc2-inner h3 {
    min-height: 123px;
    margin-bottom: 0;
    text-align: center;
    font-size: 46px;
    font-weight: 600;
    line-height: 60px;
    color: #000;
}
.description-of-soldoc2-inner .box-contents {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;   
    visibility: hidden;
    opacity: 0;
}
.description-of-soldoc2-inner .item-hide {
    visibility: hidden;
    opacity: 0;
}
.description-of-soldoc2-inner .item-show {
    visibility: visible;
    opacity: 1;
    animation: fadeInUp1 2s;
}
.description-of-soldoc2 .box-contents > div {
    position: relative;
    width: calc(50% - 20px);
    height: 560px;
    padding: 50px;
    border-radius: 20px;
}
.description-of-soldoc2 .box-contents > div:first-child {
    background: #EBF7FE;
}
.description-of-soldoc2 .box-contents > div:nth-child(2) {
    background: #008DEF;
}
.description-of-soldoc2 .box-contents > div:last-child {
    width: 100%;
    height: 379px;
    margin-top: 41px;
    background: #F4F6F9;
}
.description-of-soldoc2 .box-contents > div:first-child::before {
    content: '';
    position: absolute;
    bottom: 0;
    right: 38px;
    width: 302px;
    height: 230px;
    background: url(../../assets/partners_pc/img_description_of_soldoc4.gif) 0 0 no-repeat;
    background-size: 338px auto;
}
.description-of-soldoc2 .box-contents > div:nth-child(2)::before {
    content: '';
    position: absolute;
    bottom: 50px;
    right: 51px;
    width: 252px;
    height: 232px;
    background: url(../../assets/partners_pc/img_description_of_soldoc5.gif) 0 0 no-repeat;
    background-size: 252px auto;
}
.description-of-soldoc2 .box-contents > div:last-child::before {
    content: '';
    position: absolute;
    top: 78px;
    right: 132px;
    width: 234px;
    height: 205px;
    background: url(../../assets/partners_pc/img_description_of_soldoc3.png) 0 0 no-repeat;
    background-size: 234px auto;
}
.description-of-soldoc2 .box-contents > div span {
    display: block;
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    color: #008DEF;
}
.description-of-soldoc2 .box-contents > div strong {
    font-size: 28px;
    font-weight: 600;
    line-height: 40px;
    color: #1A1A1A;
}
.description-of-soldoc2 .box-contents > div p {
    margin-top: 28px;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    color: #1A1A1A;
}
.description-of-soldoc2 .box-contents > div:nth-child(2) * {
    color: #fff;
}
.description-of-soldoc2 .box-contents > div:nth-child(2) span {
    color: #EBF7FE;
}
@keyframes fadeInUp1 {
    0% {
        opacity: 0;
        transform: translate3d(0, 30%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pc_partners/DescriptionOfSoldoc2.vue